const locale = {
    placeholder: 'Escolla hora',
    rangePlaceholder: ['Hora de inicio', 'Hora de fin'],
};
export default locale;
